<n-slide-window id="create_homedir-rule_cifs_share_slidewindow" *ngIf="pageReady" [visible]="windowVisible" width="7rem"
    (onHide)="close()">
    <n-header>
        <h1>{{i18n.title.addMappingRule}}</h1>
        <n-help-link key="cifshomedirAddMap"></n-help-link>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" class="common-form">
        <!-- 所属租户 -->
        <n-form-item [label]="i18n.label.vStoreLab">
            <div id="create-homedir-rule-cifs-share-vstore" class="n-form-item-text">{{vstoreName || UNPLACEHOLDER}}</div>
        </n-form-item>
        <!-- 用户名 -->
        <n-form-item
            [label]="i18n.label.userName"
            required="true">
            <input type="text"
                id="create-homedir-rule_cifs_user_name"
                nInput
                [nTooltip]="userName"
                nTooltipTrigger="focus"
                nTooltipPlacement="left"
                formControlName="NAME">
            <ng-template #userName>
                <span [innerHTML]="i18n.tip.userName"></span>
            </ng-template>
        </n-form-item>
        <!-- 文件系统 -->
        <n-form-item [label]="i18n.label.fileSystem" [required]="true">
            <div class="interval-10 custom-width">
                <n-select #fsSelect
                    id="create-homedir-rule-cifs-share-fs"
                    [rest]="fileSystemRest"
                    [valueField]="'ID'"
                    [labelField]="'NAME'"
                    [filter]="true"
                    formControlName="fsId"
                    (onChange)="onChooseFileSystem($event)">
                </n-select>
                <button nButton
                    id="create_homedir-rule-cifs-share-create-fs"
                    [label]="i18n.btn.createBtn"
                    type="button"
                    [disabled]="createFsDisabled"
                    (click)="createFs()">
                </button>
            </div>
        </n-form-item>
        <!-- dtree -->
        <n-form-item [label]="i18n.label.dtree">
            <n-select id="create-nfs-share-fs"
                [rest]="dtreeRest"
                [valueField]="'ID'"
                [labelField]="'NAME'"
                [filter]="!!dtreeRest"
                formControlName="dtree"
                [clearBtn]="true"
                (onChange)="onChooseDtree($event)">
            </n-select>
            <n-tip type="warning" *ngIf="dtreePathHasBackslash"
                [content]="i18n.tip.dtreePathHasBackslash">
            </n-tip>
        </n-form-item>
        <!-- 共享路径，只展示 -->
        <n-form-item [required]="false" [label]="i18n.label.share_path">
            <n-inline-loading *ngIf="pathLoading" state="loading"></n-inline-loading>
            <div *ngIf="!pathLoading"
                id="create-homedir-rule-cifs-share-share_path"
                class="text-wrap n-form-item-text">
                {{share_path || UNPLACEHOLDER}}
            </div>
        </n-form-item>

        <!-- 优先级 -->
        <n-form-item [label]="i18n.label.priority"
            [helpContent]="i18n.tip.priority"
            [required]="true">
            <n-spinner id="create-homedir-rule-cifs-share-priority"
                [min]="1" [onlyInput]="true" [rangeTip]="true"
                [max]="1024" formControlName="priority">
            </n-spinner>
        </n-form-item>
        <!-- autoCreate 自动创建 -->
        <n-form-item [label]="i18n.label.autoCreate"
            [helpContent]="i18n.tip.autoCreate">
            <n-checkbox id="create-homedir-rule-cifs-share-autoCreate"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="autoCreate">
            </n-checkbox>
        </n-form-item>

    </form>

    <n-footer>
        <button id="create-homedir-rule-cifs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="create-homedir-rule-cifs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
